<section id="index-ceo-section">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-6">
                <div class="ceo-image-wrapper">
                    <img src="assets/internal/ceo-image.png" alt="Portrait of Powell Industries CEO" class="img-fluid mx-auto">
                    <div class="ceo-badge">
                        <span class="badge-label">Founder &amp; CEO</span>
                        <span class="badge-name">Alanté "Alan" D. Powell</span><br>
                        <small class="mb-0 text-primary">Full-Stack Software Engineer</small>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="ceo-content">
                    <div class="ceo-pill">
                        <span class="dot"></span>
                        <span>Meet the CEO</span>
                    </div>
                    <h2 class="text-white">"Every launch is personal. We don't ship anything we wouldn't stake Powell Industries on."</h2>
                    <p class="lead text-primary">Alan built PI to remove the bureaucracy between inspiration and execution. With a background in enterprise infrastructure and product strategy, he champions a culture where engineers, designers, and operators collaborate as one studio.</p>
                    <div class="ceo-highlights">
                        <div>
                            <h5 class="text-white">8+ Years</h5>
                            <div class="horizontal-decorator-line-highlight my-2"></div>
                            <p>Scaling digital programs and modernizing enterprise stacks.</p>
                        </div>
                        <div>
                            <h5 class="text-white">Global Clients</h5>
                            <div class="horizontal-decorator-line-highlight my-2"></div>
                            <p>Retail, finance, public sector, and high-growth tech partners.</p>
                        </div>
                        <div>
                            <h5 class="text-white">Studio Ethos</h5>
                            <div class="horizontal-decorator-line-highlight my-2"></div>
                            <p>Customer-first delivery, measurable outcomes, transparent comms.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
